import {
  firstPickupStop,
  lastDeliveryStop,
  PlannedOrder,
} from "@/reducers/plannedOrdersSlice"
import { resolveCountryCode } from "./vehicleSuggestions"

export const countryCodeToFlagEmoji = (countryCode?: string): string | null =>
  countryCode && /^[A-Za-z]{2}$/.test(countryCode)
    ? countryCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(127397 + char.charCodeAt(0)),
        )
    : null

// From-country and to-country flags of a planned order (pickup -> delivery)
export const plannedOrderFlags = (
  order: PlannedOrder,
): { from: string | null; to: string | null } => ({
  from: countryCodeToFlagEmoji(
    resolveCountryCode(firstPickupStop(order)?.location),
  ),
  to: countryCodeToFlagEmoji(
    resolveCountryCode(lastDeliveryStop(order)?.location),
  ),
})
